import './js/modal-recipe.js';
import './js/categories.js';
import './js/main.section.js';

// swiper
import './js/swiper/swiper';

import './js/modal-recipe.js';
import './js/categories.js';
import './js/main.section.js';
import './js/popular-recipes.js';
import './js/header.js';
import './js/order-now-modal';
